import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src879763043/src/codemochi-courses/src/components/routes/public/Lecture.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="objective">
  <p>
    <span>Objective:</span> Add the create recipe mutation to the
    GenerateIngredients component so that we can make new recipes.
  </p>
    </div>
    <p>{`In this step we are going to create the createRecipe Mutation that we can use for submitting data to the backend. First we should add the `}<inlineCode parentName="p">{`useFetchUser`}</inlineCode>{` hook to fetch the user information. We will use the user id so that we can assign an owner to the recipe when it is created. This will control which user is able to view the recipe in their `}<inlineCode parentName="p">{`my-recipes`}</inlineCode>{` route as well as update or delete the recipe.`}</p>
    <p>{`We use the `}<inlineCode parentName="p">{`useMutation`}</inlineCode>{` hook to have a `}<inlineCode parentName="p">{`createRecipeMutation`}</inlineCode>{` function that we can use for triggering the mutation after the submit button is pressed. While the mutation is loading, we are sure to disable the submit button so that users can't double click the button accidentally.`}</p>
    <p>{`First, as a tiny cleanup issue from the last step, remove the console.log from `}<inlineCode parentName="p">{`utils/submitForm.ts`}</inlineCode>{` in the `}<inlineCode parentName="p">{`handleDeleteIngredient`}</inlineCode>{` function as we won't need it any more.`}</p>
    <p>{`Next, let's get to building the `}<inlineCode parentName="p">{`createRecipeMutation`}</inlineCode>{` function in the `}<inlineCode parentName="p">{`<CreateRecipe>`}</inlineCode>{` component. After creating the function, you'll also want to add a disabled prop to the Create Recipe button. This will ensure it gets disabled when we are waiting for it to get submitted and someone won't accidentally double click on it and send 2 mutations. We also want to add a check for loading and show a `}<inlineCode parentName="p">{`<Loading/>`}</inlineCode>{` component while the user information is still fetching.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-components/CreateRecipe.tsx"
      }}>{`import { Row, Col, Form, Button } from 'antd';
import { submitForm } from '../utils/submitForm';
import { GenerateInput, GenerateTextInput } from './GenerateFields';
import { GenerateIngredients } from './GenerateIngredients';
import { useMutation } from '@apollo/react-hooks';
import { createRecipeGraphQL } from '../graphql/mutations/createRecipe';
import { useFetchUser } from '../utils/user';
import * as _ from 'lodash';
import { Loading } from './notify/Loading';
import Router from 'next/router';

export const CreateRecipe = () => {
  const [createRecipeMutation, { loading }] = useMutation(createRecipeGraphQL);
  const { user, loading: isFetchingUser } = useFetchUser();
  const owner = _.get(user, 'sub');

  const initiateCreateRecipe = () => {
    createRecipeMutation({
      variables: {
        data: {
          ...inputs,
          owner,
        },
      },
    });
    Router.replace('/my-recipes');
  };

  const {
    inputs,
    handleInputChange,
    handleAddIngredient,
    handleDeleteIngredient,
    handleDropdownChange,
    handleSubmit,
  } = submitForm(
    {
      title: '',
      description: '',
      content: '',
      ingredients: [],
    },
    initiateCreateRecipe,
  );

  if (isFetchingUser) return <Loading />;

  return (
    <Form onFinish={handleSubmit}>
      <GenerateInput
        name="title"
        value={inputs.title}
        handleInputChange={handleInputChange}
      />
      <GenerateInput
        name="description"
        value={inputs.description}
        handleInputChange={handleInputChange}
      />
      <GenerateTextInput
        name="content"
        value={inputs.content}
        handleInputChange={handleInputChange}
      />
      <GenerateIngredients
        names={['amount', 'unit', 'type']}
        values={inputs.ingredients}
        handleAddIngredient={handleAddIngredient}
        handleDeleteIngredient={handleDeleteIngredient}
        handleInputChange={handleInputChange}
        handleDropdownChange={handleDropdownChange}
      />
      <Row>
        <Col span={16} />
        <Col span={4}>
          <Form.Item label="Create Recipe">
            <Button disabled={loading} type="primary" htmlType="submit">
              Create Recipe
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      